module.exports = __webpack_public_path__ + "img/guam.851bfab2.svg";